import { render, staticRenderFns } from "./AdminDashboardMobileInfo.vue?vue&type=template&id=851153a8&"
import script from "./AdminDashboardMobileInfo.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardMobileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports